import React from "react";
import "./DeleteConfirmModal.css";
import { Trash2, Archive } from "lucide-react"; // 1. Pridėta Archive ikona
import { useTranslation } from "react-i18next";

// 2. Pridėti nauji props: title, message, isArchive, btnText
function DeleteConfirmModal({ worker, onClose, onConfirm, title, message, isArchive, btnText }) {
  const { t } = useTranslation();

  if (!worker) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-box delete"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-icon">
          {/* 3. LOGIKA: Jei archyvas - Archive ikona, jei ne - Trash2 */}
          {isArchive ? <Archive size={42} /> : <Trash2 size={42} />}
        </div>

        <h2 className="modal-title danger">
          {/* 4. LOGIKA: Jei adminas atsiuntė pavadinimą - rodom jį */}
          {title || t("deleteWorkerTitle")}
        </h2>

        <p className="delete-text">
          {/* 5. LOGIKA: Jei adminas atsiuntė žinutę - rodom ją */}
          {message ? (
             message
          ) : (
             <>
               {t("deleteWorkerConfirm")}
               <span className="delete-name"> {worker.name}</span>
             </>
          )}
        </p>

        <div className="delete-actions">
          <button
            className="btn-delete"
            onClick={() => onConfirm(worker.id)}
          >
            {/* 6. LOGIKA: Mygtuko ikona ir tekstas */}
            {isArchive ? <Archive size={18} /> : <Trash2 size={18} />}
            {btnText || t("delete")}
          </button>

          <button
            className="btn-cancel"
            onClick={onClose}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;